import { Component, OnInit, OnDestroy } from '@angular/core';
import {Location} from '@angular/common';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {Roomlisting,RoomlistingService } from './roomlisting.services';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title,BrowserModule,DomSanitizer,SafeHtml} from '@angular/platform-browser';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import { MetaService } from 'ng2-meta';
import { CopyWriteService} from './../services/copywrite.service';


declare var jQuery: any;
interface Room {
  roomTitle: string;
  description: string;
  meta_title: string;
  meta_description: string;
  room_price:string;
  two_person_room_price:string;
  extra_bad_price:string;
  meal_plan:string;
  view_from_room:string;
  bed_type:string;
  separate_sitting_area:string;
  max_person_allow:string;
  room_size:string;
  room_size_type:string;
  amanities:Array<any>;
  smoking_non_smoking:string;
  balcony:string;
  image1:string;
  image2:string;
  image3:string;
  image4:string;
  image5:string;
  
  
  
  
}

let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";
let hotemodel;



if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    //console.log("hotel:->"+JSON.stringify(jsonObject));
    
    if(jsonObject.hotel)
    {
	    hotemodel=true;
    }
    else
    {
	    hotemodel=false;
    }
}

let componentdata;
if(hotemodel)
{
   componentdata={templateUrl: './pg/hotel/roominfo.component.html'}
}
else
{
   componentdata={template: '<div></div>'}   
   
}
@Component(componentdata)

export class RoominfoComponent implements OnInit {
	
	
	room: Room;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    public backdatareceived=false;
    public roomdata;
    
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private metaService: MetaService,
	    private _location:Location,
	    private _sanitizer: DomSanitizer,
	    private slimLoadingBarService: SlimLoadingBarService,
	    private copywriteservice:CopyWriteService,
	    private _pageService: RoomlistingService) {
		   
		   this.room = {
                  roomTitle:'',
				  description: '',
				  meta_title: '',				  
				  meta_description: '',
				  room_price:'',
				  two_person_room_price:'',
				  extra_bad_price:'',
				  meal_plan:'',
				  view_from_room:'',
				  bed_type:'',
				  separate_sitting_area:'',
				  image1:'',
				  image2:'',
				  image3:'',
				  image4:'',
				  image5:'',
				  amanities:[],
				  max_person_allow:'',
				  room_size:'',
				  room_size_type:'',
				  smoking_non_smoking:'',
				  balcony:''
				  
                 
				  	}
		 if(this.shareService.getroominfo()!=undefined)
	    {
		    this.backdatareceived=true;
		    this.roomdata= this.shareService.getroominfo();		    
		    //this.room.roomTitle=roomdata.roomTitle;
		    console.log("roomdata start");
		    //this._title.setTitle(roomdata.roomTitle); 
		    
		    console.log(this.roomdata);
		    console.log(this.roomdata.roomTitle);
		    
		    
		          this.room.roomTitle=this.roomdata.roomTitle;
		         
		     	  this._title.setTitle(this.roomdata.roomTitle);                  
                   /*this.room.description=this.roomdata.description;
                  this.room.room_price=this.roomdata.room_price;
                  this.room.two_person_room_price=this.roomdata.two_person_room_price;
                  this.room.extra_bad_price=this.roomdata.extra_bad_price;
                  this.room.meal_plan=this.roomdata.meal_plan;
                  this.room.view_from_room=this.roomdata.view_from_room;
                  this.room.bed_type=this.roomdata.bed_type;
                  this.room.separate_sitting_area=this.roomdata.separate_sitting_area;
                  this.room.max_person_allow=this.roomdata.max_person_allow;
                  this.room.smoking_non_smoking=this.roomdata.smoking_non_smoking;                  
                  this.room.balcony=this.roomdata.balcony;
                  this.room.room_size_type=this.roomdata.room_size_type;
                  this.room.room_size=this.roomdata.room_size;
                  this.room.image1=this.roomdata.image1;
                  this.room.image2=this.roomdata.image2;
                  this.room.image3=this.roomdata.image3;
                  this.room.image4=this.roomdata.image4;
                  this.room.image5=this.roomdata.image5;
                  this.room.amanities=this.roomdata.amanities;*/
                  
	   }	
		   
		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh hhhnaga";
	   // alert("page");
	  //if(!this.backdatareceived)
	   {
		   this.slimLoadingBarService.start();
		   this._sub = this._route.params.subscribe(params => {
			let slug =params['slug'];			
			 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);				   
			   
			   this._pageService.getRoom(slug).subscribe(
        data => {
                 // 
                                   
                  this.room.roomTitle=data.room.roomTitle;
                  if(data.room.meta_title)
                  this._title.setTitle(data.room.meta_title);
                  else
                  this._title.setTitle(data.room.roomTitle);
                  
                  this.room.description=data.room.description;
                  this.room.room_price=data.room.room_price;
                  this.room.two_person_room_price=data.room.two_person_room_price;
                  this.room.extra_bad_price=data.room.extra_bad_price;
                  this.room.meal_plan=data.room.meal_plan;
                  this.room.view_from_room=data.room.view_from_room;
                  this.room.bed_type=data.room.bed_type;
                  this.room.separate_sitting_area=data.room.separate_sitting_area;
                  this.room.max_person_allow=data.room.max_person_allow;
                  this.room.smoking_non_smoking=data.room.smoking_non_smoking;                  
                  this.room.balcony=data.room.balcony;
                  this.room.room_size_type=data.room.room_size_type;
                  this.room.room_size=data.room.room_size;
                  this.room.image1=data.room.image1;
                  this.room.image2=data.room.image2;
                  this.room.image3=data.room.image3;
                  this.room.image4=data.room.image4;
                  this.room.image5=data.room.image5;
                  this.room.amanities=data.room.amanities;                                    
                 setTimeout(()=>{    //<<<---    using ()=> syntax
         
                
			      let copywrite=this.shareService.getcopywrite();  
			      //console.log("Mydata->"+this.siteinfo.site_address);        
			      this.copywriteservice.copywritelogo(copywrite);
				  },1000);
				  
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title); 
                   let mainjs=this.shareService.getmainjs();
				   jQuery.getScript('./'+mainjs);                              
              
               this.slimLoadingBarService.complete();
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			  
			   
			   
			   		   
		});
	    }
		
	
		
	}
	
   public backbtn() {
    
       this._location.back();
    }
    
     public transform(value: string): SafeHtml {
		return this._sanitizer.bypassSecurityTrustHtml(value);

	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/hotel/roominfo.component.ts